import { mapGetters } from 'vuex'
import file from '@/api/file'
import publisher from '@/api/publisher'
import journal from '@/api/journal'
import subscribe from '@/api/subscribe'

export default {
  data() {
    return {
      publisherInfo: {},
      domain: '',
      journalInfo: {},
      params: {
        id: '',
        type: ''
      },
      result: false
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage'
    })
  },
  async mounted() {
    const { journalName, id, type } = this.$route.query
    this.params = { id, type }
    this.getDomain()
    this.getPublisherInfo(journalName)
    this.getQuery()
  },
  methods: {
    async getQuery() {
      const { subscribed } = await subscribe.getState(this.params)
      this.result = !subscribed
    },
    async getPublisherInfo(journalName) {
      this.publisherInfo = await publisher.query('imr')
      await this.getJournalInfo(journalName)
    },
    async getJournalInfo(val) {
      if (!val) {
        return
      }
      this.journalInfo = await journal.webQuery(val, {
        publisherId: this.publisherInfo.id
      })
    },
    async getDomain() {
      this.domain = await file.domain()
    },
    async submit(subscribed) {
      const data = Object.assign(this.params, { subscribed })
      await subscribe.openMail(data)
      if (subscribed) {
        this.goToPage()
      } else {
        this.result = true
      }
    },
    goToPage() {
      window.location.href = `https://www.imrpress.com/journal/${this.journalInfo.name}`
    }
  }
}
